"use client";
import { useAtom } from "jotai";
import { WindowWidthAtom } from "./dim-hook";
import { mobileHeaderBreakPoint } from "@/utils/functions/global-constants";

export const useIsMobile = () => {
  const [w] = useAtom(WindowWidthAtom);
  return w <= mobileHeaderBreakPoint;
};
